import React from 'react';
import Styles from "./Inpnut.module.css"
import "../UI/public.css";


const Input = (props) => {


  return (
    <input

      {...props}

      // className={
      //   props.className !== undefined ?
      //     props.color !== undefined ?
      //       props.className + " " + props.color + " " + Styles.default_btn_style
      //       :
      //       props.className + "greenBtn " + Styles.default_btn_style // green is default style
      //     :
      //     props.color !== undefined ?
      //       props.color + " " + Styles.default_btn_style
      //       :
      //       "greenBtn " + Styles.default_btn_style // green is default style
      // }
      className={props.className !== undefined ?
        props.className + " " + Styles.default_input_style
        :
        Styles.default_input_style
      }

    />
  )

};

export default Input;
